"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Right = function () {
  /*
    bekannte Rechte:
    1: alle Kunden
    2: meine Daten
    3: alle Verträge
    4: meine Verträge
    5: alle Konten/Accounts
    6: mein Account
    7: Formulare
    */

  function Right(description, read, create, edit, del) {
    _classCallCheck(this, Right);

    this.Description = description; //Bezeichnung
    this.Read = read;
    this.Create = create;
    this.Edit = edit;
    this.Delete = del;
  }

  _createClass(Right, [{
    key: "getRight",
    value: function getRight() {
      return this;
    }
  }]);

  return Right;
}();

exports.default = Right;